<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

                <v-card>

                    <v-breadcrumbs divider="/">
                        <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                        <v-breadcrumbs-item to="/properties" :exact="true" :disabled="false">Grupe</v-breadcrumbs-item>
                        <v-breadcrumbs-item :disabled="true">Izmena</v-breadcrumbs-item>
                    </v-breadcrumbs>

                </v-card>

                <v-card class="fix-card">

                    <form>

                        <v-text-field
                                v-model="property.title"
                                :error="error_messages.title == false"
                                :error-messages="error_messages.title"
                                label="Naziv grupe"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="property.order"
                                :error="error_messages.order == false"
                                :error-messages="error_messages.order"
                                label="Redosled"
                                required
                        ></v-text-field>

                        <v-checkbox
                                label="Vidljivo"
                                v-model="property.is_visible"
                                color="primary"
                        ></v-checkbox>

                        <v-btn @click="submit()" color="primary">Potvrdi</v-btn>
                        <v-btn @click="clear()" color="secondary" class="black--text">Očisti</v-btn>

                    </form>

                </v-card>

            </v-flex>

            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/properties/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>

        </v-layout>

    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data () {
            return {
              fillable: ['title', 'slug', 'order', 'is_visible',],
              property: {},
              error_messages: [],
            }
        },
        mounted(){
            this.getProperty();
        },
        computed: {
            userProfile(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getProperty(){
                axios.get('properties/' + this.$route.params.id)
                    .then(res => {
                      this.property = res.data.property;
                    })
                    .catch(e => {
                        console.log(e);
                        this.error = e.response.data.errors;
                    });
            },
            submit(){
                let data = fillForm(this.fillable, this.property, 'PUT');
                axios.post(`properties/${this.property.id}`, data)
                    .then( res => {
                        this.property = res.data.property;
                        swal({
                            position: 'center',
                            type: 'success',
                            title: 'Uspeh',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( e => {
                        console.log(e.response.data);
                        this.error_messages = e.response.data;
                    });
            },
            clear(){
              this.user.title = '';
              this.user.order = '';
              this.user.is_visible = false;
              this.error_messages = [];
            },
        }
    }
</script>
